// ============================================================
// locales/cdpresse_relayeur_translations.js
// Traductions FR / EN pour la page Relayeur CdPresse
// Usage : i18n.t('relayeur.hero.title_1')
// ============================================================

export const cdpresseRelayeurTranslations = {
  fr: {
    relayeur: {

      // ── Payment ──────────────────────────────────────────────
      payment: {
        processing: 'Traitement en cours...',
        back: 'Retour',
        pay: 'Payer',
        cancel: 'Annuler',
        change_payment_method: 'Changer le mode de paiement',
        done: 'Terminé',
        continue: 'Continuer',
        payment: 'Paiement',
        amount_to_pay: 'Montant à payer',
        payment_method: 'Moyen de paiement',
        via_mobile_money: 'Par mobile money',
        by_credit_card: 'Par carte de crédit/débit',
        by_card: 'Par carte',
        phone_number: 'Numéro de téléphone',
        payment_successful: 'Paiement réussi.',
        registration_confirmed: 'Votre inscription à la formation est confirmée.',
        registration_number: `Numéro d'inscription`,
        participation_details: `Les détails de participation ont été envoyés à votre adresse email`,
        phone_number_required: 'Le numéro de téléphone est requis',
        phone_number_incomplete: 'Le numéro de téléphone est incomplet',
        no_zero_format: 'Format: Ne pas entrer le premier « 0 »',
        phone_number_format: `Le format du numéro n'est pas correct`,
        transaction_failed_reason: 'La transaction a échoué pour la raison suivante:',
        time_limit_expired: 'Le délai de 120 secondes a expiré avant que vous ne confirmiez le paiement',
        transaction_failed_reasons: 'La transaction a échoué pour une des raisons suivantes:',
        canceled_by_you: 'Elle a été annulée par vous',
        pin_incorrect: `Le code PIN saisi n'est pas correct`,
        balance_insufficient: 'Le solde de votre compte est insuffisant',
        exp_date_cvv_incorrect: `La date d'expiration ou le code CVC/CVV que vous avez saisi est incorrect`,
        bank_declined: `La banque émettrice de la carte a refusé la transaction pour une raison non précisée`,
        confirm_payment_on_your_phone: 'Confirmez le paiement sur votre téléphone...',
        processing_payment: 'Traitement du paiement en cours...',
        payment_request_proxypay: `Une demande de paiement va être envoyée sur votre téléphone via notre partenaire de paiement mobile PROXYPAY ARAKA. Veuillez vérifier que ce nom apparaît sur votre téléphone avant de confirmer avec votre code PIN.`,
        payment_request_maishapay: `Une demande de paiement va être envoyée sur votre téléphone via notre partenaire de paiement mobile MAISHAPAY MAISHA. Veuillez vérifier que ce nom apparaît sur votre téléphone avant de confirmer avec votre code PIN.`,
        do_not_close_window: `Ne fermez pas cette fenêtre`,

        card_number: 'Numéro de la carte',
        cardholder_name: `Nom du titulaire de la carte`,
        expiration_date: `Date d'expiration`,
        cardholder_name_error: `Le nom du titulaire de la carte !`,
        expiration_date_error: `La date d'expiration !`,
        security_code_error: 'Le code de sécurité !',

      },

      // ── Registration ──────────────────────────────────────────────
      registration: {
        continue: 'Continuer',
        all_day: 'Journée',
        previous: 'Précédent',
        today: `Aujourd'hui`,
        next: 'Suivant',
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour',
        agenda: 'Agenda',
        date: 'Date',
        hour: 'Heure',
        event: 'Evénement',
        no_sessions_in_period: 'Aucune session dans cette période',
        legend: 'Légende',
         list: 'Liste',
         calendar: 'Calendrier',
         level: 'Niveau',
         all_levels: 'Tous les niveaux',
         starter: 'Starter',
         verified: 'Vérifié',
         pro: 'Pro',
         format: 'Format',
         all_formats: 'Tous les formats',
         presential: 'Présentiel',
         online: 'En ligne',
         available_spots: 'Places disponibles',
         full: 'Complet',
         session_full: 'Session complète',
         register: `S'enregistrer`,
         loading_sessions: 'Chargement des sessions...',
         no_sessions_available: `Aucune session disponible pour le niveau et/ou le format sélectionné(s). Veuillez modifier vos filtres.`,
         loading_calendar: `Chargement du calendrier...`,
         training_registration: `Inscription à la formation`,
         remaining_spots: `Places restantes`,
         continue_to_payment: `Continuer vers le paiement`,
         date: 'Date',
         location: 'Lieu',
         price: 'Prix',
         first_name: 'Prénom',
         last_name: 'Nom',
         phone: 'Téléphone',
         province: 'Province/Région/Etat',
         country: 'Pays',
         cancel: 'Annuler',
         province_required: 'La province est requise',
         phone_required: 'Le format du téléphone est incorrect',
         email_required: `Le format de l'email est incorrect`,
         name_required: 'Le nom est requis',
         firstname_required: 'Le prénom est requis',
      },

      // ── Hero ──────────────────────────────────────────────
      hero: {
        eyebrow:     'Programme Relayeur · CdPresse',
        title_1:     'Devenez',
        title_2:     'Relayeur.',
        tagline:     `Monétisez votre capacité à faire circuler l'information dans un réseau de syndication distribué.`,
        title_parag: `Pour devenir RELAYEUR CDPRESSE, la première étape consiste à s’enregistrer au programme de formation.`,
        body_parag: `Vous devez choisir le niveau de formation qui correspond le mieux à votre profil parmi les 3 niveaux proposés. Ensuite, sélectionnez la date de formation qui vous convient selon les disponibilités affichées, remplissez le formulaire d’inscription et effectuez le paiement afin de confirmer votre participation. Les formations sont actuellement disponibles en deux formats: en présentiel ou en ligne, selon votre préférence et les options proposées.`,
        pillars: [
          {
            icon:  'diffusion_icon.png',
            titre: 'Diffusion',
            desc:  `Partagez des communiqués vérifiés et participez à la circulation de l'information officielle.`,
          },
          {
            icon:  'tracabilite_icon.png',
            titre: 'Traçabilité',
            desc:  `Un lien personnel unique pour suivre précisément l'impact de chaque diffusion en temps réel.`,
          },
          {
            icon:  'monetisation_icon.png',
            titre: 'Monétisation',
            desc:  `Soyez rémunéré pour la portée et l'engagement réels que vous créez.`,
          },
        ],
      },

      // ── Funnel ────────────────────────────────────────────
      funnel: {
        label:    'VOTRE PARCOURS',
        title_1:  'Comment devenir',
        title_2:  'Relayeur ?',
        subtitle: `Une infrastructure de distribution monétisée de l'information avec formation intégrée.`,
        steps: [
          { label: 'Enregistrement', sub: 'Paiement' },
          { label: 'Formation',      sub: 'Certification' },
          { label: 'Activité',       sub: '1er revenu guidé · Activité continue' },
          { label: 'Relayeur Pro',   sub: 'Loop viral' },
        ],
        formation_label: 'Formation intégrée',
        formation_body:  'Nous ne vous donnons pas seulement une formation. Nous vous donnons accès à un système de revenus, un statut vérifié et à la monétisation.',
        formation_highlights: ['système de revenus', 'statut vérifié', 'monétisation'],
      },

      // ── Niveaux ───────────────────────────────────────────
      niveaux: {
        label:    'NIVEAUX STRATÉGIQUES',
        title_1:  'Trois niveaux de',
        title_2:  'formation',
        subtitle: 'Progressez à votre rythme et développez vos compétences en communication et distribution digitale.',
        explore:  'Rejoindre',
        what_you_do: 'Ce que vous faites',
        who_its_for: 'Pour qui',
        what_you_get: 'Ce que vous obtenez',
        relayeur_cap_nosp: 'RELAYEUR',
        items: [
          {
            id:     'starter',
            code:   'RLY-01',
            tag:    'Starter',
            prix:   '30$',
            titre:  'Relayeur Starter',
            accroche: `Entrez dans l'économie de la diffusion`,
            description: `Devenez Relayeur et commencez à gagner de l'argent en diffusant des communiqués de presse vérifiés via vos réseaux sociaux et communautés.`,
            actions: [
              'Partager des communiqués via votre lien unique',
              'Générer des vues, clics et engagements',
              'Apprendre les bases de la diffusion digitale',
            ],
            obtenu: [
              'Accès à la plateforme CdPresse',
              'Liens trackés personnels',
              'Tableau de bord de performance',
              'Certification "Relayeur Starter"',
            ],
            cible:  ['Étudiants', 'Jeunes actifs', 'Créateurs débutants', 'Utilisateurs de réseaux sociaux'],
            status: 'DISPONIBLE',
          },
          {
            id:     'verifie',
            code:   'RLY-02',
            tag:    'Vérifié',
            prix:   '75$',
            titre:  'Relayeur Vérifié',
            accroche: `Devenez un relais professionnel de l'information`,
            description: `Passez au niveau supérieur et transformez votre activité de diffusion en véritable compétence monétisable. Vous devenez un relais fiable dans un réseau d'information structuré.`,
            actions: [
              'Diffuser des communiqués stratégiques',
              'Optimiser votre portée et vos performances',
              'Travailler avec des campagnes plus rémunératrices',
            ],
            obtenu: [
              'Tout du niveau Starter',
              'Accès à campagnes premium',
              'Meilleure rémunération par CPM',
              'Insights avancés de performance',
              'Badge "Relayeur Vérifié"',
            ],
            cible:  ['Jeunes communicants', 'Influenceurs locaux', 'Journalistes débutants', 'Community managers'],
            status: 'DISPONIBLE',
          },
          {
            id:     'pro',
            code:   'RLY-03',
            tag:    'Pro',
            prix:   '150$',
            titre:  'Relayeur Pro',
            accroche: 'Créez et dirigez votre propre réseau de diffusion',
            description: `Devenez un opérateur de distribution d'information. Construisez et gérez un réseau de relayeurs et multipliez vos revenus grâce à l'effet de levier.`,
            actions: [
              'Diffuser des campagnes à forte valeur',
              'Recruter et gérer des relayeurs',
              'Organiser la diffusion en réseau',
              'Optimiser la performance collective',
            ],
            obtenu: [
              'Tout du niveau Vérifié',
              'Accès au modèle de syndication (revenus multi-niveaux)',
              'Possibilité de créer votre équipe de relayeurs',
              'Dashboard réseau (performance individuelle + équipe)',
              'Accès aux campagnes institutionnelles et politiques',
              'Statut "Relayeur Pro certifié"',
            ],
            cible:  ['Entrepreneurs digitaux', 'Médias locaux', 'Communicants professionnels', 'Leaders de communauté', 'Jeunes agences informelles'],
            status: 'DISPONIBLE',
          },
        ],
      },

      // ── Modèle économique ─────────────────────────────────
      modele: {
        label:    'MODÈLE ÉCONOMIQUE',
        title_1:  'Comment vous êtes',
        title_2:  'rémunéré',
        body:     `CdPresse est une infrastructure de distribution d'information qui transforme les communiqués en actifs monétisés et mesurables, avec un système de rémunération basé sur la performance réelle et la qualité de l'attention générée.`,
        aut_rev_alloc: 'ALLOCATION_AUTOMATIQUE',
        flux_steps: [
          {
            num:   '01',
            label: 'Paiement client',
            desc:  'Un émetteur (parti, entreprise, institution) paie une campagne.',
          },
          {
            num:   '02',
            label: 'Distribution Pool',
            desc:  'CdPresse transforme le budget en actif de diffusion circulant.',
          },
          {
            num:   '03',
            label: 'Allocation automatique',
            desc:  '35 % Relayeurs · 25 % Syndicateurs · 30 % Plateforme · 10 % Bonus.',
          },
        ],
        allocation: [
          { label: 'Relayeurs',              pct: 35, color: '#cc74c6' },
          { label: 'Syndicateurs (médias)',   pct: 25, color: '#3498db' },
          { label: 'Plateforme',             pct: 30, color: '#8888aa' },
          { label: 'Bonus performance',      pct: 10, color: '#27ae60' },
        ],
        allocation_example: 'Ex : Client paie 1 000$ → 350$ pour les Relayeurs du réseau',
        chain: [
          { titre: 'ÉMETTEUR (Client)',           desc: 'Parti, entreprise, institution' },
          { titre: 'CDPRESSE (Orchestrateur)',     desc: 'Transforme le budget en actif de diffusion' },
          { titre: 'RÉSEAU DE DISTRIBUTION',      desc: 'Relayeurs + Syndicateurs + Plateforme' },
          { titre: 'AUDIENCE',                    desc: 'Attention mesurée en temps réel' },
        ],
      },


      // ── Rémunération ──────────────────────────────────────
      remuneration: {
        label:    'CALCUL DE LA RÉMUNÉRATION',
        title_1:  `Bien plus qu'un`,
        title_2:  'simple clic',
        subtitle: 'La rémunération repose sur plusieurs paramètres combinés, et non sur un simple paiement au clic.',
        params: [
          {
            icon:  'vue_icon.png',
            titre: 'Vues qualifiées',
            desc:  'Nombre de vues réelles, uniques et valides générées par votre diffusion.',
          },
          {
            icon:  'partage_icon.png',
            titre: 'Partages & diffusion secondaire',
            desc:  'Reprises, repartages et amplification générés à partir de votre activité.',
          },
          {
            icon:  'cpm_icon.png',
            titre: 'CPM',
            desc:  'Coût pour mille vues qualifiées, référence servant de base au calcul de la portée générée.',
          },
          {
            icon:  'engagement_icon.png',
            titre: 'Engagement',
            desc:  'Temps de lecture, clics pertinents, actions déclenchées autour du communiqué.',
          },
        ],
        blocs: [
          {
            titre:    'Bonus de performance',
            color:    '#27ae60',
            negative: false,
            items:    ['Portée exceptionnelle', `Forte qualité d'engagement`, 'Effet réseau généré', 'Amplification secondaire significative'],
            note:     `Ces bonus viennent s'ajouter à la rémunération de base.`,
          },
          {
            titre:    'Score de qualité',
            color:    '#3498db',
            negative: false,
            items:    ['Diversité et authenticité du trafic', `Profondeur d'engagement`, 'Cohérence des audiences atteintes', 'Qualité globale de la diffusion'],
            note:     `Valorise la qualité de l'attention générée, pas seulement le volume.`,
          },
          {
            titre:    'Intégrité & Anti-fraude',
            color:    '#8e0f58',
            negative: true,
            items:    ['Trafic automatisé ou robots', 'Clics ou vues suspects', 'Répétitions artificielles', 'Comportements de manipulation'],
            note:     'Les métriques sont filtrées pour garantir une performance réelle et qualifiée.',
          },
        ],
      },

      // ── CTA ───────────────────────────────────────────────
      cta: {
        label:     'REJOINDRE LE RÉSEAU',
        title_1:   'Transformez votre réseau',
        title_2:   'en revenu.',
        body:      `Transformez la circulation de l'information en opportunité économique.`,
        cta_label: 'Rejoindre',
        contact:   'prince@debyoo.com · +243 815 923 212 · NEW YORK · BRUXELLES · KINSHASA',
        contact_phone_1:   'prince@debyoo.com · +243 815 923 212',
        contact_phone_2:   'NEW YORK · BRUXELLES · KINSHASA',
      },

      // ── FAQ ───────────────────────────────────────────────
      faq: {
        title: '❓ Questions Fréquentes',

        items: [
          {
            question: "Comment s'inscrire ?",
            answer: "Sélectionnez une session, remplissez le formulaire et effectuez le paiement.",
          },
          {
            question: "Quelle est la différence entre les niveaux ?",
            answer: "Chaque niveau offre un niveau de formation différent avec des revenus potentiels croissants.",
          },
          {
            question: "Où se déroulent les formations présentiel ?",
            answer: "À Silikin Village, Kinshasa (Gombe).",
          },
          {
            question: "Comment accéder aux formations en ligne ?",
            answer: "Le lien Zoom/Meet/Teams vous est envoyé par email 24h avant la session.",
          },
        ],
      },

    },
  },

  en: {
    relayeur: {

      // ── Payment ──────────────────────────────────────────────
      payment: {
        processing: 'Processing...',
        back: 'Back',
        pay: 'Pay',
        cancel: 'Cancel',
        change_payment_method: 'Change payment method',
        done: 'Done',
        continue: 'Continue',
        payment: 'Payment',
        amount_to_pay: 'Amount to pay',
        payment_method: 'Payment method',
        via_mobile_money: 'Via mobile money',
        by_credit_card: 'By credit/debit card',
        by_card: 'By card',
        phone_number: 'Phone number',
        payment_successful: 'Payment successful.',
        registration_confirmed: 'Your registration for the training has been confirmed.',
        registration_number: 'Registration number',
        participation_details: 'Participation details have been sent to your email address',
        phone_number_required: 'The phone number is required',
        phone_number_incomplete: 'The phone number is incomplete',
        no_zero_format: `Format: Do not enter the leading « 0 »`,
        phone_number_format: 'The phone number format is incorrect',
        transaction_failed_reason: 'The transaction failed for the following reason:',
        time_limit_expired: 'The 120-second time limit expired before you confirmed the payment',
        transaction_failed_reasons: 'The transaction failed for one of the following reasons:',
        canceled_by_you: 'It was canceled by you',
        pin_incorrect: 'The PIN entered is incorrect',
        balance_insufficient: 'Your account balance is insufficient',
        exp_date_cvv_incorrect: 'The expiration date or CVC/CVV code you entered is incorrect',
        bank_declined: 'The issuing bank declined the transaction for an unspecified reason',
        confirm_payment_on_your_phone: 'Confirm the payment on your phone...',
        processing_payment: 'Processing payment...',
        payment_request_proxypay: `A payment request will be sent to your phone via our mobile payment partner PROXYPAY ARAKA. Please verify that this name appears on your phone before confirming with your PIN code.`,
        payment_request_maishapay: `A payment request will be sent to your phone via our mobile payment partner MAISHAPAY MAISHA. Please verify that this name appears on your phone before confirming with your PIN code.`,
        do_not_close_window: `Do not close this window`,
        cardholder_name:`The cardholder’s name !`,
        expiration_date: 'The expiration date !',

        card_number: 'Card number',
        cardholder_name: `Cardholder’s name.`,
        expiration_date: `Expiration date`,
        cardholder_name_error: `The cardholder’s name. !`,
        expiration_date_error: `The expiration date !`,
        security_code_error: 'The security code !',
      },

      // ── Registration ──────────────────────────────────────────────
      registration: {
        continue: 'Continue',
        all_day: 'All day',
        previous: 'Previous',
        today: 'Today',
        next: 'Next',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        agenda: 'Agenda',
        date: 'Date',
        hour: 'Hour',
        event: 'Event',
        no_sessions_in_period: 'No sessions during this period',
        legend: 'Legend',
         list: 'List',
         calendar: 'Calendar',
         level: 'Level',
         all_levels: 'All levels',
         starter: 'Starter',
         verified: 'Verified',
         pro: 'Pro',
         format: 'Format',
         all_formats: 'All formats',
         presential: 'Presential',
         online: 'Online',
         available_spots: 'Available spots',
         full: 'Full',
         session_full: 'Session full',
         register: `Register`,
         loading_sessions: 'Loading sessions...',
         no_sessions_available: 'No sessions available for the selected level and/or format. Please adjust your filters.',
         loading_calendar: 'Loading calendar...',
         training_registration: 'Training registration',
         remaining_spots: 'Remaining spots',
         continue_to_payment: 'Continue to payment',
         date: 'Date',
         location: 'Location',
         price: 'Price',
         first_name: 'First name',
         last_name: 'Last name',
         phone: 'Phone',
         province: 'State/Region/Province',
         country: 'Country',
         cancel: 'Cancel',
         province_required: 'The province is required',
         phone_required: 'The phone format is incorrect',
         email_required: `The email format is incorrect`,
         name_required: 'The last name is required',
         firstname_required: 'The first name is required',
      },

      // ── Hero ──────────────────────────────────────────────
      hero: {
        eyebrow:  'Relayer Partner Program · CdPresse',
        title_1:  'Become a',
        title_2:  'Relay Partner.',
        tagline:  'Monetize your ability to spread information across a distributed syndication network.',
        title_parag: `To become a CDPRESSE RELAY PARTNER, the first step is to register for the training program.`,
        body_parag: `You must choose the training level that best matches your profile from the 3 levels available. Then, select the training date that suits you based on the available schedule, fill out the registration form, and complete the payment to confirm your participation. The training sessions are currently available in two formats: in-person or online, depending on your preference and the available options.`,
        pillars: [
          {
            icon:  'diffusion_icon.png',
            titre: 'Distribution',
            desc:  'Share verified press releases and participate in the circulation of official information.',
          },
          {
            icon:  'tracabilite_icon.png',
            titre: 'Traceability',
            desc:  'A unique personal link to precisely track the impact of each distribution in real time.',
          },
          {
            icon:  'monetisation_icon.png',
            titre: 'Monetization',
            desc:  'Get paid for the real reach and engagement you create.',
          },
        ],
      },

      // ── Funnel ────────────────────────────────────────────
      funnel: {
        label:    'YOUR JOURNEY',
        title_1:  'How to become',
        title_2:  'a Relay Partner?',
        subtitle: 'A monetized information distribution infrastructure with integrated training.',
        steps: [
          { label: 'Registration', sub: 'Payment' },
          { label: 'Training',     sub: 'Certification' },
          { label: 'Activity',     sub: '1st guided income · Ongoing activity' },
          { label: 'Pro Relay Partner',  sub: 'Viral loop' },
        ],
        formation_label: 'Integrated Training',
        formation_body:  'We don\'t just give you training. We give you access to a revenue system, a verified status, and monetization.',
        formation_highlights: ['revenue system', 'verified status', 'monetization'],
      },

      // ── Niveaux ───────────────────────────────────────────
      niveaux: {
        label:    'STRATEGIC LEVELS',
        title_1:  'Three training',
        title_2:  'levels',
        subtitle: 'Progress at your own pace and develop your skills in communication and digital distribution.',
        explore:  'Join',
        what_you_do: 'What you do',
        who_its_for: `Who it's for`,
        what_you_get: 'What you get',
        relayeur_cap_nosp: 'RELAYPARTNER',
        items: [
          {
            id:     'starter',
            code:   'RLY-01',
            tag:    'Starter',
            prix:   '$30',
            titre:  'Starter Relay Partner',
            accroche: 'Enter the distribution economy',
            description: 'Become a Relay Partner and start earning money by distributing verified press releases through your social networks and communities.',
            actions: [
              'Share press releases via your unique link',
              'Generate views, clicks, and engagement',
              'Learn the basics of digital distribution',
            ],
            obtenu: [
              'Access to the CdPresse platform',
              'Personal tracked links',
              'Performance dashboard',
              '"Starter Relay Partner" certification',
            ],
            cible:  ['Students', 'Young professionals', 'Beginner creators', 'Social media users'],
            status: 'AVAILABLE',
          },
          {
            id:     'verifie',
            code:   'RLY-02',
            tag:    'Verified',
            prix:   '$75',
            titre:  'Verified Relay Partner',
            accroche: 'Become a professional information relay',
            description: 'Level up and turn your distribution activity into a true monetizable skill. You become a trusted relay in a structured information network.',
            actions: [
              'Distribute strategic press releases',
              'Optimize your reach and performance',
              'Work with higher-paying campaigns',
            ],
            obtenu: [
              'Everything in Starter',
              'Access to premium campaigns',
              'Better CPM compensation',
              'Advanced performance insights',
              '"Verified Relay Partner" badge',
            ],
            cible:  ['Young communicators', 'Local influencers', 'Junior journalists', 'Community managers'],
            status: 'AVAILABLE',
          },
          {
            id:     'pro',
            code:   'RLY-03',
            tag:    'Pro',
            prix:   '$150',
            titre:  'Pro Relay Partner',
            accroche: 'Build and lead your own distribution network',
            description: 'Become an information distribution operator. Build and manage a network of Relay Partners and multiply your income through leverage.',
            actions: [
              'Distribute high-value campaigns',
              'Recruit and manage Relay Partners',
              'Organize network-based distribution',
              'Optimize collective performance',
            ],
            obtenu: [
              'Everything in Verified',
              'Access to the syndication model (multi-level income)',
              'Ability to create your own Relay Partner team',
              'Network dashboard (individual + team performance)',
              'Access to institutional and political campaigns',
              '"Certified Pro Relay Partner" status',
            ],
            cible:  ['Digital entrepreneurs', 'Local media', 'Professional communicators', 'Community leaders', 'Informal young agencies'],
            status: 'AVAILABLE',
          },
        ],
      },

      // ── Modèle économique ─────────────────────────────────
      modele: {
        label:    'BUSINESS MODEL',
        title_1:  'How you get',
        title_2:  'paid',
        body:     'CdPresse is an information distribution infrastructure that turns press releases into monetized, measurable assets, with a compensation system based on real performance and the quality of attention generated.',
        aut_rev_alloc: 'AUTOMATIC_REVENUE_ALLOCATION',
        flux_steps: [
          {
            num:   '01',
            label: 'Client payment',
            desc:  'An issuer (party, company, institution) pays for a campaign.',
          },
          {
            num:   '02',
            label: 'Distribution Pool',
            desc:  'CdPresse transforms the budget into a circulating distribution asset.',
          },
          {
            num:   '03',
            label: 'Automatic allocation',
            desc:  '35% Relay Partners · 25% Syndicators · 30% Platform · 10% Bonus.',
          },
        ],
        allocation: [
          { label: 'Relayers',             pct: 35, color: '#cc74c6' },
          { label: 'Syndicators (media)',   pct: 25, color: '#3498db' },
          { label: 'Platform',             pct: 30, color: '#8888aa' },
          { label: 'Performance bonus',    pct: 10, color: '#27ae60' },
        ],
        allocation_example: 'E.g. Client pays $1,000 → $350 distributed to network Relay Partners',
        chain: [
          { titre: 'ISSUER (Client)',              desc: 'Party, company, institution' },
          { titre: 'CDPRESSE (Orchestrator)',       desc: 'Transforms the budget into a distribution asset' },
          { titre: 'DISTRIBUTION NETWORK',         desc: 'Relay Partners + Syndicators + Platform' },
          { titre: 'AUDIENCE',                     desc: 'Measured attention in real time' },
        ],
      },

      // ── Rémunération ──────────────────────────────────────
      remuneration: {
        label:    'COMPENSATION BREAKDOWN',
        title_1:  'Much more than',
        title_2:  'a simple click',
        subtitle: 'Compensation is based on multiple combined parameters, not a simple pay-per-click model.',
        params: [
          {
            icon:  'vue_icon.png',
            titre: 'Qualified views',
            desc:  'Number of real, unique, and valid views generated by your distribution.',
          },
          {
            icon:  'partage_icon.png',
            titre: 'Shares & secondary distribution',
            desc:  'Reposts, reshares, and amplification generated from your activity.',
          },
          {
            icon:  'cpm_icon.png',
            titre: 'CPM',
            desc:  'Cost per thousand qualified views, the baseline for calculating generated reach.',
          },
          {
            icon:  'engagement_icon.png',
            titre: 'Engagement',
            desc:  'Reading time, relevant clicks, actions triggered around the press release.',
          },
        ],
        blocs: [
          {
            titre:    'Performance bonuses',
            color:    '#27ae60',
            negative: false,
            items:    ['Exceptional reach', 'High engagement quality', 'Network effect generated', 'Significant secondary amplification'],
            note:     'These bonuses are added on top of the base compensation.',
          },
          {
            titre:    'Quality score',
            color:    '#3498db',
            negative: false,
            items:    ['Diversity and authenticity of traffic', 'Depth of engagement', 'Consistency of audiences reached', 'Overall distribution quality'],
            note:     'Values the quality of attention generated, not just volume.',
          },
          {
            titre:    'Integrity & Anti-fraud',
            color:    '#8e0f58',
            negative: true,
            items:    ['Automated traffic or bots', 'Suspicious clicks or views', 'Artificial repetitions', 'Manipulation or fraudulent inflation'],
            note:     'Metrics are filtered to ensure compensation is based on real, qualified performance.',
          },
        ],
      },

      // ── CTA ───────────────────────────────────────────────
      cta: {
        label:     'JOIN THE NETWORK',
        title_1:   'Turn your network',
        title_2:   'into revenue.',
        body:      'Transform the circulation of information into economic opportunity.',
        cta_label: 'Join',
        contact:   'prince@debyoo.com · +243 815 923 212 · NEW YORK · BRUSSELS · KINSHASA',
        contact_phone_1:   'prince@debyoo.com · +243 815 923 212',
        contact_phone_2:   'NEW YORK · BRUSSELS · KINSHASA',
      },

      // ── FAQ ───────────────────────────────────────────────
      faq: {
        title: '❓ Frequently Asked Questions',

        items: [
          {
            question: "How do I register?",
            answer: "Select a session, fill out the form, and complete the payment.",
          },
          {
            question: "What is the difference between the levels?",
            answer: "Each level offers a different training depth with increasing earning potential.",
          },
          {
            question: "Where do in-person trainings take place?",
            answer: "At Silikin Village, Kinshasa (Gombe).",
          },
          {
            question: "How do I access online trainings?",
            answer: "The Zoom/Meet/Teams link is sent to you by email 24 hours before the session.",
          },
        ],
      },

    },
  },
}
